import React, { Fragment, useEffect, useState } from 'react'
import { useLocation } from "react-router-dom";
import { Link } from 'react-router-dom'
import { ItemsDesplegables } from './ItemsDesplegables'
import { ItemsPlanes } from './ItemsPlanes'

export const NavBar = () => {

    const { pathname } = useLocation();
    const [vehiculos, setvehiculos] = useState([]);
    const [concesionarioDropdownVisible, setConcesionarioDropdownVisible] = useState(false);
    const [urlConcesionarias, setUrlConcesionarias] = useState("");

    useEffect(() => {
        fetch("/modelos_planes_cuotas")
            .then(res => res.json())
            .then(result => {
                if (result.estado !== 0) {
                    setvehiculos(result);
                }
            });

        fetch("/get_url_concesionarios")
            .then(res => res.json())
            .then(data => {
                if (data && data.url) {
                    setUrlConcesionarias(data.url);
                }
            })
            .catch(error => {
                console.error("Error fetching concesionarias URL:", error);
            });
    }, []);



    // if(!vehiculos.length) return <p>Actualizando</p>
    //nueva rama

    // let habilitar = vehiculos.length == 0;

    const [size, setSize] = useState(window.innerWidth);
    window.addEventListener('resize', () => {
        setSize(window.innerWidth);
    });

    const toggleDropdown = () => {
        setConcesionarioDropdownVisible((prev) => !prev);
    };

    // Los desplegables de Planes y de Suscribite muestran la misma grilla de modelos. El de
    // Suscribite agrega el hash que hace que la pantalla del plan scrollee hasta el formulario.
    const modelosDesplegable = (hash = "") =>
        vehiculos.length != 0 ? (
            vehiculos.map(veh => (
                <Fragment key={veh.id}>
                    <div className="collapseDiv--plan_div">
                        <ItemsPlanes link={"/planes/auto/" + veh.id + hash} name={veh.titulo} amount={veh.cuota_desde} img={veh.hash_foto} id={veh.id} pixelTags={veh.pixel_tags} />
                    </div>
                </Fragment >
            ))
        ) : (
            <div className="d-flex flex-column w-100 justify-content-center align-items-center">
                <p className="mt-2">Actualizando Planes, volver más tarde</p>
            </div>
        );

    useEffect(() => {
        let setFocus = (path, btn) => {

            if (pathname.includes(path)) {
                let button = document.querySelector(btn)

                if (button) {
                    button.classList.add('hoverFocus');
                }

            } else {
                let button = document.querySelector(btn)

                if (button) {
                    button.classList.remove('hoverFocus')
                }
            }
        };

        setFocus('acto_de_adjudicacion', '.actoBtn');
        setFocus('conoce_fiat_plan', '.conoceBtn');
        setFocus('informacion_general', '.infoBtn');
        setFocus('planes', '.planesBtn');
        setFocus('planes', '.planesBtnMobile');



        let collapseDiv = document.querySelectorAll(".collapseDiv");
        let drodpdownFixed = path => {
            if (path === pathname) {
                if (size < 992) {
                    collapseDiv.forEach(collapse => collapse.style.top = "116px")
                } else {
                    collapseDiv.forEach(collapse => collapse.style.top = "144px")
                }
            }
        };

        let paths = [
            "/cuotas",
            "/inicio",
            "/mis_datos",
            "/notificaciones",
            "/instructivos"
        ];
        let path = paths.filter(path => path === pathname);
        if (path.length > 0) {
            drodpdownFixed(path[0]);
        } else {
            if (size < 992) {
                collapseDiv.forEach(collapse => collapse.style.top = "60px")
            } else {
                collapseDiv.forEach(collapse => collapse.style.top = "90px")
            }
        }




    }, [pathname])



    return (
        <header>
            <nav className='nav'>
                <div className="nav-container">
                    <div className="logo">
                        <Link to={'/'}>
                            <button>
                                <img
                                    className="logoMobile"
                                    src="/images/header/fiat.svg"
                                />
                                <img
                                    className="logoDesktop"
                                    src="/images/header/logo_fiat.svg"
                                />
                            </button>
                        </Link>
                    </div>

                    <div className="ul-container">
                        <ul>
                            <li className="d-flex btn planesNav">
                                <button className="nav_button nav_button_desktop planesBtn" data-expandible="planes"
                                    // disabled={habilitar}
                                    role="button" aria-haspopup="true" aria-expanded="false" >
                                    Planes
                                    <img className="ml-octa" src='/images/icons/arrow-white-down.svg' />
                                </button>
                            </li>
                            <li>
                                <Link to={'/conoce_fiat_plan'}>
                                    <button className="conoceBtn">
                                        CONOCÉ FIAT PLAN
                                    </button>

                                </Link>
                            </li>
                            <li>
                                <Link to={'/acto_de_adjudicacion'}>
                                    <button className="actoBtn">
                                        Acto de adjudicación
                                    </button>
                                </Link>
                            </li>
                            <li>
                                <Link to={'/informacion_general'}>
                                    <button className="infoBtn">
                                        Información general
                                    </button>
                                </Link>
                            </li>
                            <li>
                                <button
                                    onClick={toggleDropdown}
                                    className="nav_button nav_button_desktop"
                                    aria-haspopup="true"
                                    aria-expanded={concesionarioDropdownVisible}
                                >
                                    CONCESIONARIOS
                                </button>
                                {concesionarioDropdownVisible && (
                                    <ul className="concesionarioDropdown">
                                        <li>
                                            <a
                                                href={urlConcesionarias || "#"}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Concesionario más cercano
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/concesionarios/listado"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Listado de concesionarios
                                            </a>
                                        </li>
                                    </ul>
                                )}
                            </li>
                        </ul>
                        <div className="miplan order-sm-1">

                            <Link to={'/login_mi_plan'}>
                                <button>
                                    <p className="mb-0 text-center">Mi Plan</p>
                                </button>
                            </Link>
                        </div>
                        <div className="miplan order-sm-1">
                            <button
                                className="suscribiteBtn"
                                data-expandible="suscribite"
                                role="button"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <p className="mb-0 text-center">Suscribite</p>
                            </button>
                        </div>
                        <div className="ul-container--plan btn">
                            <button className="nav_button nav_button_desktop planesBtnMobile" data-expandible="planes"
                                // disabled={habilitar}
                                role="button" aria-haspopup="true" aria-expanded="false" >
                                Planes
                                <img className="ml-octa" src='/images/icons/arrow-white-down.svg' />
                            </button>

                        </div>
                        <div className="ul-container--mobile order-sm-3">
                            <button className="nav_button nav_button_desktop" data-expandible="menu" role="button" aria-haspopup="true" aria-expanded="false">
                                <img src='/images/icons/menu.svg' />
                            </button>
                        </div>
                    </div>
                </div>
            </nav>
            <div className="containerCollapse ">
                <div className="collapseDiv container-fluid container-fluid--main" data-expandible="planes">
                    <div className="collapseDiv--items collapseDiv--plan">
                        {modelosDesplegable()}
                    </div>
                </div>
                <div className="collapseDiv container-fluid container-fluid--main" data-expandible="suscribite">
                    <div className="collapseDiv--items collapseDiv--plan">
                        {modelosDesplegable("#mas_informacion")}
                    </div>
                </div>
                <div className="collapseDiv container-fluid container-fluid--main" data-expandible="menu">
                    <div className="collapseDiv--items d-flex flex-column">
                        <ItemsDesplegables url='/conoce_fiat_plan' text="CONOCÉ FIAT PLAN" />
                        <div className="separator--hor mt-half mb-half"></div>
                        <ItemsDesplegables url="/acto_de_adjudicacion" text="Acto de adjudicacion" />
                        <div className="separator--hor mt-half mb-half"></div>
                        <ItemsDesplegables url="/informacion_general" text="Información general" />
                        <div className="separator--hor mt-half mb-half"></div>
                        <a target="_blank" href='https://fiat-ar-prod-fca.adobecqms.net/concesionarios.html' className="items-despegables">
                            <p>concesionarios</p>
                            <img className="ml-half" src="/images/icons/small.svg" />
                        </a>
                    </div>
                </div>
            </div>
        </header>
    );
};
